var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2022-05-26 13:54:33
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-05-21 22:21:41
 * @Description:
 * @Developer:
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, Form, Input, Button, Row, Col, } from 'antd';
import APIForm from '../components/antd/APIForm';
import Api from '../api';
import BorderLayout, { BorderCenter, BorderSouth } from '../components/BorderLayout';
import Image from '../components/Image';
const api = Api();
export default class LoginPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            spinning: false
        };
    }
    render() {
        return (React.createElement(BorderLayout, { style: { background: 'url(/images/login-banner.png)', backgroundRepeat: 'no-repeat', backgroundSize: '100%' } },
            React.createElement(BorderCenter, null,
                React.createElement(Row, { justify: 'center' },
                    React.createElement(Col, null,
                        React.createElement(Image, { style: { height: 64, marginTop: 196 }, src: '/images/logo-white.png' }))),
                React.createElement(Card, { style: { width: 360, marginLeft: 'auto', marginRight: 'auto', marginTop: 200 }, title: "\u4E07\u56FE\u968F\u9884\u7EA6\u53CA\u968F\u8BBF\u8FD0\u8425\u7CFB\u7EDF" },
                    React.createElement(APIForm, { action: "/login", name: 'login-form', onBeforeRequest: (method, values) => __awaiter(this, void 0, void 0, function* () {
                            return Object.assign(Object.assign({}, values), { group: 'cn.com.one2three.admin', mode: 0 });
                        }), onRequestSucceeded: () => this.props.route.navigate('/admin/home', { replace: true }) },
                        React.createElement(Form.Item, { name: "username", rules: [{ required: true, message: '请输入已注册的账号' }] },
                            React.createElement(Input, { placeholder: '\u8F93\u5165\u5DF2\u6CE8\u518C\u7684\u90AE\u7BB1\u767B\u5F55\u7CFB\u7EDF' })),
                        React.createElement(Form.Item, { name: "password", rules: [{ required: true, message: '请输入登录密码' }] },
                            React.createElement(Input.Password, { placeholder: '\u8F93\u5165\u767B\u5F55\u5BC6\u7801' })),
                        React.createElement(Row, { align: 'middle' },
                            React.createElement(Col, { flex: 1 },
                                React.createElement(Link, { to: "/forgot_password" }, "\u5FD8\u8BB0\u5BC6\u7801\uFF1F")),
                            React.createElement(Col, null,
                                React.createElement(Button, { htmlType: 'submit', type: "primary" }, "\u767B\u5F55")))))),
            React.createElement(BorderSouth, null,
                React.createElement(Row, { justify: 'center' },
                    React.createElement(Col, null,
                        React.createElement(Button, { style: { fontSize: '16px', marginBottom: '10px' }, type: 'link', href: 'https://beian.miit.gov.cn/', target: '_blank' }, "\u7CA4ICP\u59072021034598\u53F7"))))));
    }
}
